import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface DropdownOption {
  label: string;
  value: any;
  icon?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-dropdown-button',
  templateUrl: './dropdown-button.component.html',
  styleUrl: './dropdown-button.component.scss'
})
export class DropdownButtonComponent {
  @Input() label = 'Menu';
  @Input() icon = 'chevron-down';
  @Input() options: DropdownOption[] = [];
  @Input() disabled = false;
  @Input() buttonClass = '';
  @Output() optionSelected = new EventEmitter<DropdownOption>();

  isOpen = false;

  toggleDropdown() {
    if (!this.disabled) {
      this.isOpen = !this.isOpen;
    }
  }

  selectOption(option: DropdownOption) {
    if (!option.disabled) {
      this.optionSelected.emit(option);
      this.isOpen = false;
    }
  }
}
